import { AxiosClone } from "./../AxiosClone"
import { api_url } from "../Configuration/Config"

//login
export async function adminLogin(data) {
    console.log('Login API URL:', `${api_url}/admin/auth/login`);
    console.log('Login Data:', data);
    return await AxiosClone.post(`${api_url}/admin/auth/login`, data)
}
